import React from 'react';
import './awards.css';
import AwardCard from '../awardCard/awardCard'
import Grid from '@material-ui/core/Grid';
import { getAwards } from '../../services/contentService';

class Awards extends React.Component {
    constructor(props) {
      super(props);
      this.state = {projects:[],loading:true};
      // To use the 'this' keyword, we need to bind it to our function
    }
    async componentDidMount(){
        try {
            const projects = await getAwards();
            this.setState({projects,loading:false});
        } catch (_) {
            this.setState({projects:[], loading:false});
        }
    }

    handleSubmit(){

    }

    getloading(){
        return(
               <div className = 'loader-container'>
                 <div className = 'spinner'></div>
               </div>
        );
       }


       getGrid(){
        return(
            <Grid container className='gridList' alignItems="center"
   alignContent='space-between' spacing={3}>
            {this.state.projects.map(project=>(<Grid item key={project.slug} className='award-card-grid' xs={6} sm={4}  md={3} lg={2}><AwardCard item={project} /></Grid>))}
            </Grid>
        )
       }

    render(){ 
        const response = this.state.loading?this.getloading():this.getGrid();

        return (
            <div className="award-card" >
                <div className='title'>
                Awards / Recognitions
            </div>
            <div>
            {response}
        </div>
            </div>


        )
    }

}

export default Awards;